<div class="card card-default">
    <div class="card-header title_size">
        <h2 class="card-title">Create Factory Projection</h2>
        <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>

    <div class="card-body">







        <form class="form-data" [formGroup]="factoryCreationForm" (ngSubmit)="submit()">
            <div class="d-flex justify-content-end ">
                <button type="submit" class="submit">Submit</button>
            </div>
            <section class="main-page-box">
                <div class="row">
                    <div class="col-12 col-sm-8 col-md-6">
                        <div class="row">
                            <div class="col-12">
                                <label for="year_month" class="required">Year and Month</label>
                                <input class="form-control" name="year_month" type="month" id="year_month"
                                    formControlName="year_month">
                                <!-- <select name="uom" id="" formControlName="uom">
                                    <option value=""></option>
                                </select> -->
                                <div *ngIf="factoryCreationForm.get('uom')?.invalid && factoryCreationForm.get('uom')?.touched"
                                    class="text-danger">
                                    Year and month require
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="product_id" class="required">Material Name</label>
                                <ng-select [virtualScroll]="true" (change)="product($event)" [items]="MaterialDropdown"
                                    bindLabel="product_name" placeholder="Material" name="product_id" id="product"
                                    bindValue="product_id" formControlName="material_id" required
                                    class="generic-input"></ng-select>
                                <div *ngIf="factoryCreationForm.get('material_id')?.invalid && factoryCreationForm.get('material_id')?.touched"
                                    class="text-danger">
                                    Material is required
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="uom" class="required">UOM</label>
                                <input class="form-control" readonly name="uom" id="uom" formControlName="uom">
                                <!-- <select name="uom" id="" formControlName="uom">
                                    <option value=""></option>
                                </select> -->
                                <div *ngIf="factoryCreationForm.get('uom')?.invalid && factoryCreationForm.get('uom')?.touched"
                                    class="text-danger">
                                    Product doesnt have UOM
                                </div>
                            </div>

                            <div class="col-12">
                                <label for="product_id" class="required">Intermediate Material Name</label>
                                <ng-select [virtualScroll]="true" [items]="intermediateDropdown"
                                    bindLabel="product_name" placeholder="Intermediate" name="product_id" id="product"
                                    bindValue="product_id" formControlName="intermediate_material_id" required
                                    class="generic-input"></ng-select>
                                <!-- <div *ngIf="factoryCreationForm.get('intermediate_material_id')?.invalid && factoryCreationForm.get('intermediate_material_id')?.touched"
                                    class="text-danger">
                                    Intermediate is required
                                </div> -->
                            </div>

                        </div>


                    </div>
                    <div class="col-12 col-sm-8 col-md-6">
                        <div class="row">
                            <div class="col-12">
                                <label for="in_liter" class="required">In Liter</label>
                                <input class="form-control" type="number" name="in_liter" id="in_liter"
                                    formControlName="in_liter">
                                <div *ngIf="factoryCreationForm.get('in_liter')?.invalid && factoryCreationForm.get('in_liter')?.touched"
                                    class="text-danger">
                                    Required
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="approved_quantity" class="required">Approved Quantity</label>
                                <input  class="form-control" type="number"
                                    name="approved_quantity" id="approved_quantity" formControlName="approved_quantity">
                                <div *ngIf="factoryCreationForm.get('approved_quantity')?.invalid && factoryCreationForm.get('approved_quantity')?.touched"
                                    class="text-danger">
                                    Approved Quantity Required
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="per_can_qty_in_kg" class="required">per can qty in kg</label>
                                <input  class="form-control" type="number"
                                    name="per_can_qty_in_kg" id="per_can_qty_in_kg" formControlName="per_can_qty_in_kg">
                                <div *ngIf="factoryCreationForm.get('per_can_qty_in_kg')?.invalid && factoryCreationForm.get('per_can_qty_in_kg')?.touched"
                                    class="text-danger">
                                    Qty is Required
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="total_req_intermediate" class="required">Total Req Intermediate</label>
                                <input class="form-control" type="number" name="total_req_intermediate"
                                    id="total_req_intermediate" formControlName="total_req_intermediate">
                                <div *ngIf="factoryCreationForm.get('total_req_intermediate')?.invalid && factoryCreationForm.get('total_req_intermediate')?.touched"
                                    class="text-danger">
                                    Total is Required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </form>























    </div>
</div>